import React, { useEffect, useState } from 'react';
import { MessageBar } from './MessageBar';
import styles from './PlanBreadcrumb.module.scss';
import { icons } from '../../assets';
import { ADMIN_SETTINGS } from '../../constants/routePathConstants';
const { ArrowDownIcon } = icons;

function PlanBreadcrumb({ stickyHeader = false,hideError = false ,message, actions, hideBack, goBackText = 'Back', goBack = () => {} }) {
  const [scrollValue, setScrollValue] = useState(0);
 
  useEffect(() => {
    const handleScroll = () => {
      if(stickyHeader){
        setScrollValue(window.scrollY);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollHeight = window.location?.pathname === ADMIN_SETTINGS ? 70 : 20
  
  return (
    <div className={`${styles.container} ${scrollValue > scrollHeight && styles.activeScroll} ${stickyHeader ? `${styles.stickyHeader}` : ''}`}>
      {!hideBack && (
        <div className={styles.info} onClick={goBack}>
          {!hideError && <ArrowDownIcon
            style={{
              width: 20,
              height: 20,
              transform: 'rotate(90deg)',
            }}
          />}
          <div className={styles.iconText}>{goBackText}</div>
        </div>
      )}
      {message && (
        <MessageBar
          style={{
            marginBottom: 0,
          }}
          text={message}
          actions={actions}
          keepActionNextAfterText
        />
      )}
    </div>
  );
}

export default PlanBreadcrumb;
